
import moment from 'moment'
import MenuIcon from '@mui/icons-material/Menu'
import React, { Fragment as F, useContext, useEffect, useRef, useState } from 'react'
import Modal from 'react-modal'

import {
  Link,
  useParams,
} from "react-router-dom"

import config from 'config'
import {
  PeriodsCtx,
} from '../periods'
import {
  formatLineitem,
  SchedulesCtx,
} from './'
import {
  appRouter,
  C,
  logg,
  useApiRouter,
} from '$shared'
import { AppCtx } from '$src/App'


/**
 * ScheduleShow
**/
const ScheduleShow = (props) => {
  // logg(props, 'ScheduleShow')

  const apiRouter = useApiRouter()
  const params    = useParams()

  const {
    actionName, setActionName,
    currentUser, setCurrentUser,
    joyrideRun, setJoyrideRun,
    loading, setLoading,
    loading2, setLoading2,
    userConfig,
  } = useContext(AppCtx)
  // logg(useContext(AppCtx), 'AppCtx in ScheduleShow')

  const {
    selectedPeriods,
    selectedPeriodsReverse,
  } = useContext(PeriodsCtx)
  // logg(useContext(PeriodsCtx), 'useContext(PeriodsCtx)')

  const [ schedule, setSchedule ] = useState({ lineitems: [], periods: [] })
  const [ unauthorized, setUnauthorized ] = useState(false)
  useEffect(() => {
    if (!params.rssd) { return }
    if (!params.schedule_id) { return }

    if ('ECOSYSTEM' === params.schedule_id &&
        currentUser.roles.indexOf(C.roles.INTERNAL)         === -1 &&
        currentUser.roles.indexOf(C.roles.FINTEGRATION)     === -1 &&
        currentUser.roles.indexOf(C.roles.FINTEGRATION_FDV) === -1 ) {
          setUnauthorized(true)
          return
    } else {
      setUnauthorized(false)
    }

    const tmpParams = { ...params,
      periods: Object.keys(selectedPeriods),
      periods_reverse: selectedPeriodsReverse,
    }
    if ("ORGPROF" === tmpParams.schedule_id) {
      tmpParams.periods = [ 'YTD 0' ]
    }

    // setLoading2(true) // Warning: Cannot update a component (`AppProvider`) while rendering a different component (`ScheduleShow`). https://reactjs.org/link/setstate-in-render
    fetch(apiRouter.bankSchedulePath(tmpParams)
      ).then(r => r.json()).then(inns => {
        logg(inns, 'got Schedule')
        setSchedule(inns)
        // setLoading2(false)
      })
  }, [ currentUser, params.rssd, params.schedule_id, selectedPeriods, selectedPeriodsReverse ])


  const {
    scheduleShowRef,
    schedulesList,
    schedulesOpen, setSchedulesOpen,
  } = useContext(SchedulesCtx)
  // logg(useContext(SchedulesCtx), 'SchedulesCtx in ScheduleShow')


  const [ definition,          setDefinition          ] = useState({})
  const [ fullDefinition,      setFullDefinition      ] = useState({})
  const [ definitionModalOpen, setDefinitionModalOpen ] = useState(false)

  const handleContextMenu = (props) => {
    // logg(props, 'handleContextMenu')
    const {
      ev, item,
    } = props
    // let url = `${config.drupalOrigin}/api/ubpr_codes/${item.ubpr_code}?_format=json`
    ev.preventDefault()
    if (['H3', 'BR'].indexOf(item.ubpr_code) !== -1 ) { return; }
    setDefinition({ ...item,
      ubprCode: item.ubpr_code,
      x: ev.target.getClientRects()[0].x + 20,
      y: ev.target.getClientRects()[0].y + 20,
    })
  }
  const handleClickReset = (ev) => {
    setDefinition({})
  }


  useEffect(() => {
    setJoyrideRun(true) // @TODO: this belongs elsewhere
  }, [ joyrideRun ])
  if (!schedule.lineitems.length && !unauthorized) return <F>.^.</F>


  return <F>
    <Modal
      ariaHideApp={false}
      className="DefinitionModal BaseModal"
      isOpen={definitionModalOpen}
      onRequestClose={ () => setDefinitionModalOpen(false) }
      overlayClassName="DefinitionModalOverlay"
    >
      <div className='header'>
        <h5>{fullDefinition.definition}</h5>
        <div className='close' onClick={() => setDefinitionModalOpen(false)}>&times;</div>
      </div>
      <div className='modal-content' dangerouslySetInnerHTML={{ __html: fullDefinition.body }} >
      </div>
    </Modal>

    { unauthorized ? <F><h5>Sorry, you do not have permission to access this data. Please contact the sales team at <a href="mailto:info@fedfis.com">info@fedfis.com</a>.</h5></F> :
    <div className='ScheduleShow' ref={scheduleShowRef} onClick={handleClickReset} onScroll={handleClickReset} >
      { definition.ubprCode && <div className='Definition'
                                    id='Definition'
                                    style={{ left: `${definition.x}px`, top: `${definition.y}px` }}
                               >
        { definition.definition }
      </div> }
      <table className='bordered padded sticky'  >
        <thead>
          <tr>
            <th className='schedule-name' >
              <div className='d-flex' >
                <MenuIcon onClick={() => setSchedulesOpen(schedulesOpen === C.classes.sidebarIsOpen ? C.classes.sidebarIsClosed : C.classes.sidebarIsOpen) } />
                <div className='flex-grow-1 text-center' >{ schedulesList.filter(item => item.value === params.schedule_id)[0]?.label }</div>
              </div>
            </th>
            { schedule.periods.map((p, idx) => <th key={idx} className='period'>{ moment(p).format(userConfig.dateFormat) }</th>) }
          </tr>

        </thead>
        <tbody>

          { schedule.lineitems.map((item, idx) => <tr key={idx} >
            <th className={`${'H3' === item.ubpr_code ? 'header' : '' }`} >
              <div className='tableW'
                  onContextMenu={(ev) => handleContextMenu({ev, item}) } >
                <div className='one' >{item.Row}</div>
                <div className='two align-left' >
                  { ['BR', 'H3'].indexOf(item.ubpr_code) === -1 && item.Description }
                  { 'H3' === item.ubpr_code && item.Schedule_UBPR_Code_Label }
                </div>
              </div>
            </th>
            { ['BR', 'H3'].indexOf(item.ubpr_code) === -1 && schedule.periods.map((p, idx) => <td key={idx} >{ formatLineitem( item[p], item ) }</td>) }
          </tr> )}

        </tbody>
      </table>
    </div> }
  </F>
}
export default ScheduleShow

